import Vue from 'vue'
import axios from 'axios'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import App from 'components/app-root'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    silentFallbackWarn: true,
    messages: {
        en: {
            systemtypes:{
                'undefined': 'Unknown',
                '9SYS7751': "Nordlys",
                '9SYS7773': "Sirius",
                '9SYS7852': "Ydun",
                '9SYS7853': "Ydun"
            }
        },
        da: {
            systemtypes:{
                'undefined': 'Ukendt',
                '9SYS7751': "Nordlys",
                '9SYS7773': "Sirius",
                '9SYS7852': "Ydun",
                '9SYS7853': "Ydun"
            }
        }
    }
})

Vue.prototype.$http = axios;

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import './css/custom.scss'

import VeeValidate, { Validator } from 'vee-validate'
//Vue.use(VeeValidate);
Vue.use(VeeValidate, {
    fieldsBagName: 'formFields',
    //i18n: i18n
})
import da from 'vee-validate/dist/locale/da'
Validator.localize('da', da)

var dic = {
    da: {
        attributes: {
            'email': 'E-mail',
            'first_name': 'Fornavn',
            'last_name' : 'Efternavn',
            'country' : 'Land',
            'company' : 'Firma',
            'role' : 'Rolle',
            'password' : 'Password',
            'repeatPassword' : 'Password',
            'referenceusername': 'Reference brugeren',
            'description': 'Beskrivelse',
            'mintime': 'Tids minimum',
            'maxtime': 'Tids maximum'
        },
        messages: {
            'already_exists': (field) => `${field} findes allerede.`,
            'does_not_exist': (field) => `${field} findes ikke.`,
            'verify_password': (field) => `Passwordet skal mindst indeholde: 1 stort bogstav, 1 lille bogstav, 1 tal og en special karakter (f.eks. , . _ & ? etc.).`,
            'upload_description': (field) => `Beskrivelsen skal minimum indeholde 7 ord`,
            'min_value': (field, value) => `${field} skal være større end eller lig med ${value}`
        }
    },
    en: {
        attributes: {
            'email': 'email',
            'first_name': 'first name',
            'last_name' : 'last name',
            'country' : 'country',
            'company' : 'company',
            'role' : 'role',
            'password' : 'password',
            'repeatPassword' : 'password',
            'referenceusername': 'reference user',
            'description': 'description',
            'mintime': 'minimum time',
            'maxtime': 'maximum time'
        },
        messages: {
            'already_exists': (field) => `This ${field} already exists.`,
            'does_not_exist': (field) => `The ${field} does not exist.`,
            'verify_password': (field) => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc.).`,
            'upload_description': (field) => `The description field must contain at least 7 words`
        }
    }
}

Validator.localize(dic);
VeeValidate.Validator.extend('verify_password', {
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,})");
        return strongRegex.test(value);
    }
});
VeeValidate.Validator.extend('upload_description', {
    validate: value => {
        return value.split(' ').length - 1 >= 7;
    }
});

Validator.localize('en'); // changes the locale

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faLock, faSignInAlt, faSpinner, faCheck, faTimes, faCalendar, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUser)
library.add(faLock)
library.add(faSignInAlt)
library.add(faSpinner)
library.add(faCheck)
library.add(faTimes)
library.add(faCalendar)
library.add(faCalendarAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.mixin({
	beforeCreate(){
  	const sync = this.$options.sync
  	if(sync){
    	if(!this.$options.computed){
      	this.$options.computed = {}
      }
      const attrs = Object.keys(this.$attrs)
      sync.forEach(key => {
      	if(!attrs.includes(key)){
        	Vue.util.warn(`Missing required sync-prop: "${key}"`, this)
        }
        this.$options.computed[key] = {
        	get(){
          	return this.$attrs[key]
          },
          set(val){
          	this.$emit('update:' + key, val)
          }
        }
      })
    }
  }
})

import UserModal from 'components/UserModal'
Vue.component(UserModal);

sync(store, router)
const app = new Vue({
    store,
    i18n,
    router,
    ...App
})

export {
    app,
    router,
    store
}



// WEBPACK FOOTER //
// ./WebApp/app.js